import { useState, useEffect, useCallback } from 'react'
import api from '../lib/api'

export function JobHistory() {
  const [jobs, setJobs] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('')

  const fetchJobs = useCallback(async () => {
    try {
      const params = {}
      if (filter) params.status = filter
      const res = await api.get('/sync-jobs', { params })
      setJobs(res.data)
    } catch (error) {
      console.error('Failed to fetch jobs')
    } finally {
      setLoading(false)
    }
  }, [filter])

  useEffect(() => {
    fetchJobs()
  }, [fetchJobs])

  const getStatusClass = (status) => `status-${status}`

  if (loading) return <div className="loading">Loading jobs...</div>

  return (
    <div className="job-history">
      <div className="job-filters">
        <button className={filter === '' ? 'active' : ''} onClick={() => setFilter('')}>
          All
        </button>
        <button className={filter === 'running' ? 'active' : ''} onClick={() => setFilter('running')}>
          Running
        </button>
        <button className={filter === 'completed' ? 'active' : ''} onClick={() => setFilter('completed')}>
          Completed
        </button>
        <button className={filter === 'failed' ? 'active' : ''} onClick={() => setFilter('failed')}>
          Failed
        </button>
      </div>

      {jobs.length === 0 ? (
        <p className="empty-state">No sync jobs yet.</p>
      ) : (
        <div className="jobs-table-wrapper">
          <table className="jobs-table">
            <thead>
              <tr>
                <th>Account</th>
                <th>Status</th>
                <th>Total</th>
                <th>Fetched</th>
                <th>Inserted</th>
                <th>Started</th>
                <th>Completed</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((job) => (
                <tr key={job._id}>
                  <td>{job.accountId?.email || 'Unknown'}</td>
                  <td>
                    <span className={`status-badge ${getStatusClass(job.status)}`}>{job.status}</span>
                  </td>
                  <td>{job.totalEmails.toLocaleString()}</td>
                  <td>{job.fetchedEmails.toLocaleString()}</td>
                  <td>{job.insertedEmails.toLocaleString()}</td>
                  <td>{job.startedAt ? new Date(job.startedAt).toLocaleString() : '-'}</td>
                  <td>{job.completedAt ? new Date(job.completedAt).toLocaleString() : '-'}</td>
                  <td className="error-cell" title={job.error}>
                    {job.error ? job.error.substring(0, 50) + (job.error.length > 50 ? '...' : '') : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
